import { makeAutoObservable } from "mobx";
import {
    IRefundToBankSetting
} from "../models/User";
import { IChangeable } from "./types";

interface IRefundToBankSettingChanges extends Partial<IRefundToBankSetting> {
}

type getBooleanFunc = () => boolean
type setBooleanFunc = (v: boolean) => void

class RefundToBankSettingStore implements IChangeable<IRefundToBankSettingChanges>{
    private _model: IRefundToBankSetting = {} as IRefundToBankSetting;
    private _changes: IRefundToBankSettingChanges = {};

    public toggleTableData : {
      field: string,
      translationKey: string,
      getShow: getBooleanFunc
      setShow: setBooleanFunc
      getRequire: getBooleanFunc
      setRequire: setBooleanFunc
      showToggleDisabled: getBooleanFunc,
      requireToggleDisabled: getBooleanFunc,
    }[] = [
        {
			field: 'iban_no',
			translationKey: 'IBAN_NUMBER_FIELD',
			getShow: () => true,
			getRequire: () => true,
			setShow: () => { throw new Error('Unexpected') },
			setRequire: () => { throw new Error('Unexpected') },
			showToggleDisabled: () => true,
			requireToggleDisabled: () => true,
        },
        {
			field: 'first_name',
			translationKey: 'IBAN_NAME_FIELD',
			getShow: () => this.getUpdatedModel().show_first_name,
			getRequire: () => this.getUpdatedModel().require_first_name,
			setShow: (v: boolean) => {
				this._changes.show_first_name = v;
				if (!v) {
					this._changes.require_first_name = false;
				}
			},
			setRequire: (v: boolean) => this._changes.require_first_name = v,
			showToggleDisabled: () => false,
			requireToggleDisabled: () => !this.getUpdatedModel().show_first_name,
        },
        {
			field: 'last_name',
			translationKey: 'IBAN_SURNAME_FIELD',
			getShow: () => this.getUpdatedModel().show_last_name,
			getRequire: () => this.getUpdatedModel().require_last_name,
			setShow: (v: boolean) => {
				this._changes.show_last_name = v;
				if (!v) {
					this._changes.require_last_name = false;
				}
			},
			setRequire: (v: boolean) => this._changes.require_last_name = v,
			showToggleDisabled: () => false,
			requireToggleDisabled: () => !this.getUpdatedModel().show_last_name,
        },
        {
			field: 'branch_name',
			translationKey: 'IBAN_BRANCH_NAME_FIELD',
			getShow: () => this.getUpdatedModel().show_branch_name,
			getRequire: () => this.getUpdatedModel().require_branch_name,
			setShow: (v: boolean) => {
				this._changes.show_branch_name = v;
				if (!v) {
					this._changes.require_branch_name = false;
				}
			},
			setRequire: (v: boolean) => this._changes.require_branch_name = v,
			showToggleDisabled: () => false,
			requireToggleDisabled: () => !this.getUpdatedModel().show_branch_name,
        },
        {
			field: 'branch_address',
			translationKey: 'IBAN_BRANCH_ADDRESS_FIELD',
			getShow: () => this.getUpdatedModel().show_branch_address,
			getRequire: () => this.getUpdatedModel().require_branch_address,
			setShow: (v: boolean) => {
				this._changes.show_branch_address = v;
				if (!v) {
					this._changes.require_branch_address = false;
				}
			},
			setRequire: (v: boolean) => this._changes.require_branch_address = v,
			showToggleDisabled: () => false,
			requireToggleDisabled: () => !this.getUpdatedModel().show_branch_address,
        },
        {
			field: 'comment',
			translationKey: 'IBAN_COMMENT_FIELD',
			getShow: () => this.getUpdatedModel().show_comment,
			getRequire: () => this.getUpdatedModel().require_comment,
			setShow: (v: boolean) => {
				this._changes.show_comment = v;
				if (!v) {
					this._changes.require_comment = false;
				}
			},
			setRequire: (v: boolean) => this._changes.require_comment = v,
			showToggleDisabled: () => false,
			requireToggleDisabled: () => !this.getUpdatedModel().show_comment,
        },
    ]

    constructor(refundToBankSetting: IRefundToBankSetting) {
        makeAutoObservable(this, {}, { autoBind: true });
        this.setModel(refundToBankSetting);
    }

    private setModel(model: IRefundToBankSetting) {
        if (model) {
            this._model = model;
        }
        this.discardChanges();
    }

    public hasChanges() {
        return !!Object.keys(this._changes).length;
    }

    public getUpdatedModel(): IRefundToBankSetting {
        return { ...this._model, ...this._changes };
    }

    public discardChanges(): void {
        this._changes = {};
    }

}

export default RefundToBankSettingStore;
